import { render, staticRenderFns } from "./infoTable.vue?vue&type=template&id=4119390b&scoped=true"
import script from "./infoTable.vue?vue&type=script&lang=js"
export * from "./infoTable.vue?vue&type=script&lang=js"
import style0 from "./infoTable.vue?vue&type=style&index=0&id=4119390b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4119390b",
  null
  
)

export default component.exports